import React from 'react';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ 
  currentLanguage = 'ja', 
  onLanguageChange, 
  isTranslating = false, 
  translationProgress = 0, 
  disabled, 
  isEnglishEnabled = true,
  isResearchDashboard = false,
  hasData = false
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    // If button is disabled, don't do anything
    if (disabled || isTranslating) {
      return;
    }
    
    // Toggle between languages
    const newLanguage = currentLanguage === 'ja' ? 'en' : 'ja';
    console.log('LanguageSwitcher: switching to', newLanguage);
    onLanguageChange(newLanguage);
  };

  // Determine if the button should be disabled - removed restrictions for research completion
  const isButtonDisabled = disabled || isTranslating;

  // Get the tooltip message
  const getTooltipMessage = () => {
    if (isTranslating) {
      return t('common.translating');
    }
    return '';
  };

  // Get the target language text (opposite of current language)
  const targetLanguageText = currentLanguage === 'ja' ? 'English' : '日本語';

  return (
    <button
      onClick={handleClick}
      disabled={isButtonDisabled}
      className={`flex items-center px-3 py-1.5 border border-gray-300 rounded text-sm ${
        isButtonDisabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-600 hover:bg-gray-50'
      }`}
      title={getTooltipMessage()}
    >
      <Globe size={16} className="mr-1.5" />
      {targetLanguageText}
    </button>
  );
};

export default LanguageSwitcher; 